module.exports = __webpack_public_path__ + "static/media/visual-icon@2x.d092c8d4.png";